const isJa = navigator.language.startsWith('ja');

const messages: Record<string, Record<string, string>> = {
  // App.tsx
  navBlacklist: { ja: '📝 ブラックリスト管理', en: '📝 Blocklist' },
  navViewingTime: { ja: '📊 閲覧時間統計', en: '📊 Viewing Time' },
  navCategories: { ja: '📁 カテゴリ管理', en: '📁 Categories' },
  navCategoryStats: { ja: '📈 カテゴリ別統計', en: '📈 Category Stats' },
  navChromeWebStore: { ja: 'Chrome Web Store', en: 'Chrome Web Store' },
  footerPrivacyPolicy: { ja: 'プライバシーポリシー', en: 'Privacy Policy' },

  // BlacklistDisplay
  blTitle: { ja: 'ブラックリストドメイン一覧', en: 'Blocked Domains' },
  blRedirectUrlTitle: { ja: '強制遷移先URL', en: 'Redirect URL' },
  blRedirectUrlPlaceholder: { ja: 'https://www.google.com/', en: 'https://www.google.com/' },
  blRedirectUrlNote: { ja: '未設定の場合は https://www.google.com/ にリダイレクトされます', en: 'Defaults to https://www.google.com/ if not set' },
  blTimeRestrictionTitle: { ja: '時間帯制限', en: 'Time Restriction' },
  blTimeRestrictionLabel: { ja: '時間帯・曜日を指定して制限する', en: 'Restrict by time & day of week' },
  blDayUnsetNote: { ja: '曜日未選択の場合は全曜日有効になります', en: 'If no days are selected, the rule applies every day' },
  blAddDomainTitle: { ja: 'ドメインを追加', en: 'Add Domain' },
  blAddDomainPlaceholder: { ja: 'example.com', en: 'example.com' },
  blDomainCount: { ja: '総数: {count} ドメイン', en: 'Total: {count} domains' },
  blEmptyText: { ja: 'ブラックリストに登録されたドメインがありません', en: 'No domains are blocked' },
  blFooterInfo: { ja: 'すべてのデータはブラウザ内にのみ保存されています', en: 'All data is stored locally in your browser.' },
  blErrorDuplicate: { ja: 'このドメインは既に登録されています', en: 'This domain is already registered' },
  blErrorAddFailed: { ja: 'ドメインの追加に失敗しました', en: 'Failed to add domain' },
  blErrorDeleteFailed: { ja: 'ドメインの削除に失敗しました', en: 'Failed to delete domain' },
  blErrorRedirectFailed: { ja: 'リダイレクト先URLの保存に失敗しました', en: 'Failed to save redirect URL' },
  blErrorTimeFailed: { ja: '時間帯制限の保存に失敗しました', en: 'Failed to save time restriction' },
  blErrorExtReload: { ja: '拡張機能が再読み込みされました。ページを更新してください。', en: 'Extension was reloaded. Please refresh the page.' },
  blErrorConnection: { ja: 'Chrome拡張機能との接続に失敗しました。拡張機能をインストール済みの場合は、ブラウザを再起動してからこのページを開き直してください。', en: 'Failed to connect to the Chrome extension. If installed, restart your browser and reopen this page.' },
  btnSave: { ja: '保存', en: 'Save' },
  btnSaving: { ja: '保存中...', en: 'Saving...' },
  btnAdd: { ja: '追加', en: 'Add' },
  btnAdding: { ja: '追加中...', en: 'Adding...' },
  btnDelete: { ja: '削除', en: 'Delete' },
  daySun: { ja: '日', en: 'Sun' },
  dayMon: { ja: '月', en: 'Mon' },
  dayTue: { ja: '火', en: 'Tue' },
  dayWed: { ja: '水', en: 'Wed' },
  dayThu: { ja: '木', en: 'Thu' },
  dayFri: { ja: '金', en: 'Fri' },
  daySat: { ja: '土', en: 'Sat' },

  // ViewingTimeDisplay
  vtTitle: { ja: 'サイト閲覧時間統計', en: 'Site Viewing Time Statistics' },
  vtRefresh: { ja: '🔄 最新の状態に更新', en: '🔄 Refresh' },
  vtRefreshing: { ja: '更新中...', en: 'Refreshing...' },
  vtClear: { ja: 'データをクリア', en: 'Clear Data' },
  vtDomainCount: { ja: '訪問ドメイン数', en: 'Domains Visited' },
  vtTotalTime: { ja: '総閲覧時間', en: 'Total Viewing Time' },
  vtTotalVisits: { ja: '総訪問回数', en: 'Total Visits' },
  vtStorageUsage: { ja: 'ストレージ使用量', en: 'Storage Usage' },
  vtStorageWarning: { ja: 'ストレージの空きが少なくなっています。10MBを超えると閲覧履歴の保存ができなくなります。「データをクリア」でリセットしてください。', en: 'Storage is running low. Viewing history cannot be saved beyond 10MB. Please reset with "Clear Data".' },
  vtPeriodLabel: { ja: '期間:', en: 'Period:' },
  vtPeriodAll: { ja: '全期間', en: 'All Time' },
  vtPeriodToday: { ja: '今日', en: 'Today' },
  vtPeriodWeek: { ja: '今週 (7日間)', en: 'This Week (7 days)' },
  vtPeriodMonth: { ja: '今月 (30日間)', en: 'This Month (30 days)' },
  vtSortLabel: { ja: '並び順:', en: 'Sort by:' },
  vtSortTime: { ja: '閲覧時間順', en: 'Viewing Time' },
  vtSortVisits: { ja: '訪問回数順', en: 'Visit Count' },
  vtSortRecent: { ja: '最新訪問順', en: 'Most Recent' },
  vtAutoRefresh: { ja: '自動更新 (30秒間隔)', en: 'Auto-refresh (30s)' },
  vtLastRefresh: { ja: '最終更新:', en: 'Last updated:' },
  vtPeriodNote: { ja: '直近62日分は日別、それより前は月別で集計されています。「全期間」の合計値には過去の全データが含まれます。', en: 'Data from the last 62 days is tracked daily; older data is aggregated monthly. "All Time" totals include all historical data.' },
  vtEmptyTitle: { ja: 'まだ閲覧時間データがありません', en: 'No viewing time data yet' },
  vtEmptyDesc: { ja: 'Webサイトを閲覧すると、ここに統計が表示されます', en: 'Statistics will appear here as you browse websites' },
  vtLoading: { ja: '読み込み中...', en: 'Loading...' },
  vtErrorRefresh: { ja: 'データの更新に失敗しました。Chrome拡張機能が正しく動作していることを確認してください。', en: 'Failed to refresh data. Please check that the Chrome extension is working correctly.' },
  vtErrorClear: { ja: 'データのクリアに失敗しました', en: 'Failed to clear data' },
  vtErrorConnection: { ja: 'Chrome拡張機能との接続に失敗しました。拡張機能をインストール済みの場合は、ブラウザを再起動してからこのページを開き直してください。', en: 'Failed to connect to the Chrome extension. If installed, restart your browser and reopen this page.' },
  vtPages: { ja: 'ページ', en: 'pages' },
  vtVisitCount: { ja: '回訪問', en: 'visits' },
  vtLastVisit: { ja: '最終訪問:', en: 'Last visit:' },
  vtAddToBlacklist: { ja: '＋ブラックリストに追加', en: '+ Block' },
  vtAddedToBlacklist: { ja: '追加済', en: 'Blocked' },
  vtAddingToBlacklist: { ja: '追加中...', en: 'Adding...' },
  vtAddToTag: { ja: '＋タグに追加', en: '+ Tag' },
  vtAddedToTag: { ja: '追加済', en: 'Tagged' },
  vtSelectTag: { ja: 'タグを選択', en: 'Select tag' },
  vtNoTags: { ja: 'タグがありません', en: 'No tags' },
  vtGoTagManage: { ja: 'タグ管理へ →', en: 'Manage tags →' },

  // CategoryManager
  catTitle: { ja: 'カテゴリ管理', en: 'Category Management' },
  catDescription: { ja: 'ドメインをカテゴリに分類して、カテゴリ別の閲覧時間を確認できます。', en: 'Organize domains into categories to track viewing time by category.' },
  catNamePlaceholder: { ja: 'カテゴリ名 (例: SNS, ニュース)', en: 'Category name (e.g. Social, News)' },
  catAdd: { ja: 'カテゴリ追加', en: 'Add Category' },
  catEmptyTitle: { ja: 'カテゴリがありません', en: 'No categories yet' },
  catEmptyDesc: { ja: '上のフォームからカテゴリを作成してください', en: 'Create a category using the form above' },
  catDomainCount: { ja: '{count} ドメイン', en: '{count} domains' },
  catDomainPlaceholder: { ja: 'example.com', en: 'example.com' },
  catRename: { ja: '名前変更', en: 'Rename' },
  catCancel: { ja: 'キャンセル', en: 'Cancel' },
  catErrorDuplicate: { ja: 'この名前のカテゴリは既に存在します', en: 'A category with this name already exists' },
  catErrorDomainDuplicate: { ja: 'このドメインは既にこのカテゴリに登録されています', en: 'This domain is already in this category' },

  // CategoryStats
  csTitle: { ja: 'カテゴリ別閲覧時間統計', en: 'Viewing Time by Category' },
  csEmptyTitle: { ja: 'カテゴリがありません', en: 'No categories yet' },
  csEmptyDesc: { ja: '「カテゴリ管理」タブからカテゴリを作成してください', en: 'Create categories in the "Categories" tab first' },
  csTotalTime: { ja: '合計', en: 'Total' },
  csNoDomains: { ja: 'ドメインが登録されていません', en: 'No domains registered' },
  csNoData: { ja: 'データなし', en: 'No data' },
  csUncategorized: { ja: '未分類', en: 'Uncategorized' },

  // Time format
  timeSecond: { ja: '秒', en: 's' },
  timeMinute: { ja: '分', en: 'm' },
  timeHour: { ja: '時間', en: 'h' },
  timeDay: { ja: '日', en: 'd' },
  timeToday: { ja: '今日', en: 'Today' },
  timeYesterday: { ja: '昨日', en: 'Yesterday' },
  timeDaysAgo: { ja: '日前', en: ' days ago' },

  // PrivacyPolicy
  ppTitle: { ja: 'プライバシーポリシー', en: 'Privacy Policy' },
  ppLastUpdated: { ja: '最終更新日: 2026年5月17日', en: 'Last updated: May 17, 2026' },
  ppSection1Title: { ja: '1. はじめに', en: '1. Introduction' },
  ppSection1Body: {
    ja: 'Black List Site 2 (以下「本拡張機能」) は、ユーザーのプライバシーを尊重し、個人情報の保護に努めます。本プライバシーポリシーでは、本拡張機能が収集するデータ、その使用目的、および保存方法について説明します。',
    en: 'Black List Site 2 (hereinafter "this extension") respects user privacy and is committed to protecting personal information. This Privacy Policy describes what data this extension collects, how it is used, and how it is stored.'
  },
  ppSection2Title: { ja: '2. 収集するデータ', en: '2. Data We Collect' },
  ppSection2Body: { ja: '本拡張機能は、以下のデータをユーザーのブラウザ内にのみ保存します。', en: 'This extension stores the following data only within your browser.' },
  ppSection2Item1Title: { ja: 'ブラックリスト設定データ', en: 'Blocklist settings' },
  ppSection2Item1Body: { ja: 'ユーザーが登録したブロック対象のドメイン一覧、およびリダイレクト先URL', en: 'The list of domains registered for blocking, and the redirect URL' },
  ppSection2Item2Title: { ja: '閲覧時間統計データ', en: 'Viewing time statistics' },
  ppSection2Item2Body: { ja: '訪問したサイトのドメイン名、ページURL、ページタイトル、閲覧時間、訪問回数、最終訪問日時', en: 'Domain names, page URLs, page titles, viewing time, visit counts, and last visit timestamps of visited sites' },
  ppSection3Title: { ja: '3. データの保存場所', en: '3. Where Data Is Stored' },
  ppSection3Body: { ja: 'すべてのデータは、ユーザーのブラウザのローカルストレージ (Chrome Storage API) に保存されます。', en: 'All data is stored in your browser\'s local storage (Chrome Storage API).' },
  ppSection3Bold: { ja: '外部サーバーへの送信は一切行いません。', en: 'No data is ever sent to external servers.' },
  ppSection3Item1: { ja: 'ブラックリスト設定: chrome.storage.sync (Chrome アカウント間で同期)', en: 'Blocklist settings: chrome.storage.sync (synced across Chrome accounts)' },
  ppSection3Item2: { ja: '閲覧時間統計: chrome.storage.local (端末内のみ)', en: 'Viewing time statistics: chrome.storage.local (device only)' },
  ppSection4Title: { ja: '4. データの使用目的', en: '4. How Data Is Used' },
  ppSection4Item1: { ja: 'ブラックリストに登録されたサイトへのアクセス時にリダイレクトを実行するため', en: 'To redirect when accessing sites on the blocklist' },
  ppSection4Item2: { ja: 'ユーザー自身がサイト閲覧時間を把握するための統計表示のため', en: 'To display statistics so users can track their own browsing time' },
  ppSection5Title: { ja: '5. 第三者へのデータ提供', en: '5. Third-Party Data Sharing' },
  ppSection5Body: { ja: '本拡張機能は、収集したデータを第三者に提供、販売、共有することはありません。すべてのデータはユーザーのブラウザ内に留まります。', en: 'This extension does not provide, sell, or share collected data with any third parties. All data remains within your browser.' },
  ppSection6Title: { ja: '6. 必要な権限について', en: '6. Required Permissions' },
  ppSection6Item1Title: { ja: '全URLへのアクセス', en: 'Access to all URLs' },
  ppSection6Item1Body: { ja: 'すべてのサイトでブラックリスト判定と閲覧時間の記録を行うために必要です', en: 'Required to check the blocklist and record viewing time on all sites' },
  ppSection6Item2Title: { ja: 'ストレージ', en: 'Storage' },
  ppSection6Item2Body: { ja: 'ブラックリスト設定と閲覧時間データを保存するために必要です', en: 'Required to store blocklist settings and viewing time data' },
  ppSection6Item3Title: { ja: 'タブ', en: 'Tabs' },
  ppSection6Item3Body: { ja: '現在のタブ情報を取得してブラックリスト判定を行うために必要です', en: 'Required to get current tab information for blocklist checking' },
  ppSection7Title: { ja: '7. データの削除', en: '7. Deleting Data' },
  ppSection7Body: { ja: 'ユーザーは以下の方法でデータを削除できます。', en: 'Users can delete data in the following ways.' },
  ppSection7Item1: { ja: '閲覧時間統計ページの「データをクリア」ボタンで閲覧時間データを削除', en: 'Use the "Clear Data" button on the viewing time statistics page to delete viewing time data' },
  ppSection7Item2: { ja: 'ブラックリスト管理ページで登録ドメインを個別に削除', en: 'Delete registered domains individually on the blocklist management page' },
  ppSection7Item3: { ja: 'Chrome から拡張機能をアンインストールすることで全データを削除', en: 'Uninstall the extension from Chrome to delete all data' },
  ppSection8Title: { ja: '8. お問い合わせ', en: '8. Contact' },
  ppSection8Body: { ja: '本プライバシーポリシーに関するご質問がある場合は、Chrome Web Store の拡張機能ページからお問い合わせください。', en: 'If you have any questions about this Privacy Policy, please contact us through the extension page on the Chrome Web Store.' },
};

export function t(key: string, params?: Record<string, string | number>): string {
  const entry = messages[key];
  if (!entry) return key;
  let text = isJa ? entry.ja : entry.en;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, String(v));
    });
  }
  return text;
}

export const DAY_KEYS = ['daySun', 'dayMon', 'dayTue', 'dayWed', 'dayThu', 'dayFri', 'daySat'] as const;
